import ProgressBar from '@ramonak/react-progress-bar';

import { theme } from '../../../tailwind.theme';
import { BodyRegular, H1 } from '@components/atoms/typography';
import useProgress from '@hooks/useProgress';

const LoadingView = ({
  headerText = 'Analysing your team',
  loadingText = 'Team arriving for training...',
  numberOfSeconds,
  progressBarSeconds,
  children
}: {
  headerText?: string;
  loadingText?: string;
  numberOfSeconds?: string;
  progressBarSeconds: number;
  children?: React.ReactNode;
}) => {
  const progress = useProgress(progressBarSeconds);
  return (
    <div className="flex flex-col items-center">
      <H1 className="my-3 text-center">{headerText}</H1>
      {numberOfSeconds && (
        <BodyRegular>This may take up to {numberOfSeconds} seconds</BodyRegular>
      )}
      <ProgressBar
        bgColor={theme.colors.primary[600]}
        baseBgColor={theme.colors.neutral[300]}
        height="3px"
        completed={progress}
        width="195px"
        isLabelVisible={false}
        className="mt-8 mb-4"
        animateOnRender
      />

      {children ? children : <BodyRegular>{loadingText}</BodyRegular>}
    </div>
  );
};

export default LoadingView;
